import { render, staticRenderFns } from "./AcademyLearningMapProblemInput.vue?vue&type=template&id=95a0bbde&scoped=true&lang=pug&"
import script from "./AcademyLearningMapProblemInput.vue?vue&type=script&lang=ts&"
export * from "./AcademyLearningMapProblemInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a0bbde",
  null
  
)

export default component.exports